import type { Puzzle } from '@/utils/util_types';

export type PuzzleDifficultyLevel = 'easy' | 'medium' | 'hard';

const DEFAULT_AUTHOR_NAMES = new Set([
    '海龟汤爱好者', '海龜湯愛好者', 'Turtle Soup Fan', 'タートルスープ愛好家',
    'Aficionado al Turtle Soup', 'คอเกมซุปเต่า', 'Pecinta Turtle Soup',
    '谜探', '謎探', 'The Enigma', 'El Enigma', 'ปริศนา', 'Sang Misteri',
    '미스터리', 'Das Rätsel', 'Загадка', 'Ẩn Số',
]);

export function getPuzzleDifficultyLevel(difficulty?: number | null): PuzzleDifficultyLevel | null {
    if (typeof difficulty !== 'number' || !Number.isFinite(difficulty) || difficulty < 1) return null;
    if (difficulty <= 2) return 'easy';
    if (difficulty === 3) return 'medium';
    return 'hard';
}

export function getPuzzleAuthorName(puzzle: Puzzle, fallback: string): string {
    const candidate = puzzle.origin_type === 'repost'
        ? puzzle.direct_author_name || puzzle.author
        : puzzle.author || puzzle.direct_author_name;
    return candidate && !DEFAULT_AUTHOR_NAMES.has(candidate) ? candidate : fallback;
}

/** Match the app's participation badge: hide low-signal counts and bucket large values. */
export function formatPuzzleChatNum(value?: number | null): string | null {
    const count = Number(value ?? 0);
    if (!Number.isFinite(count) || count < 50) return null;
    if (count < 100) return '50+';
    if (count < 200) return '100+';
    if (count < 500) return '200+';
    if (count < 1000) return '500+';
    return `${Math.floor(count / 1000)}k+`;
}

/** The app treats puzzles published within the last seven days as new this week. */
export function isPuzzleNewThisWeek(createdAt?: string | null): boolean {
    if (!createdAt) return false;
    const timestamp = Date.parse(createdAt);
    if (!Number.isFinite(timestamp)) return false;
    const age = Date.now() - timestamp;
    return age / (1000 * 60 * 60 * 24) <= 7;
}

export function getPuzzleDifficultyStars(difficulty?: number | null): number {
    if (typeof difficulty !== 'number' || !Number.isFinite(difficulty)) return 0;
    return Math.max(0, Math.min(5, Math.floor(difficulty)));
}
